import { FilterOptionsState } from '@mui/material';
import { Option } from 'shared-ui';

import { QueryKeyEnum } from 'core/global.enum';
import { useQuery } from 'hooks/useQuery/useQuery';
import { AnnouncementsIdSortEnum } from 'context/query/queryContext/QueryContext.enum';
import { fetchAnnouncements } from 'api/announcements/announcements';
import * as Styled from '../TableSearch.styles';

export const useSearchByServerAnnouncements = (optionsQuery: string, isEnabled: boolean, serverId?: string) => {
  const { data: announcementsResponse, isInitialLoading } = useQuery(
    [QueryKeyEnum.ANNOUNCEMENTS_SEARCH, serverId, optionsQuery],
    () => fetchAnnouncements(serverId),
    {
      args: {
        sort: [AnnouncementsIdSortEnum.ASC],
        query: optionsQuery,
      },
      enabled: isEnabled && !!serverId,
    },
  );

  const announcements = announcementsResponse?.data && serverId ? announcementsResponse?.data : [];

  const createOptions = () => {
    return announcements.map((announcement) => ({
      value: announcement.nazwa,
      label: announcement.nazwa,
    }));
  };

  const filterOptions = (options: Option[], { inputValue }: FilterOptionsState<Option>) => {
    const standarizedInputValue = inputValue.toLowerCase();

    return options.filter(
      ({ label, value }) =>
        label.toLowerCase().includes(standarizedInputValue) || `${value}`.toLowerCase().includes(standarizedInputValue),
    );
  };

  const createOptionLabel = (optionProps: React.HTMLAttributes<HTMLLIElement>, option: Option) => {
    return (
      <li {...optionProps}>
        <Styled.OptionLabel sx={{ py: 0.7 }}>{option.label}</Styled.OptionLabel>
      </li>
    );
  };

  return { isLoading: isInitialLoading, createOptions, createOptionLabel, filterOptions };
};
